import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { format, subDays } from 'date-fns';
import { DATE_FORMAT } from '../../../shared/constants';
import { smsHistoricalRecordsAdvancedFilterSchema, } from '../../../shared/types';
import useSMSActiveFiltersStore from '../stores/useSMSActiveFiltersStore';
import useGetHistoricalRecordFilters from './useGetHistoricalRecordFilters';
const useAdvancedFilterForm = () => {
    const { setActiveFilters } = useSMSActiveFiltersStore((store) => store);
    const { data } = useGetHistoricalRecordFilters();
    const offices = data?.offices || [];
    const events = data?.events || [];
    const types = data?.types || [];
    const defaultValues = {
        sender: '',
        isSent: true,
        isTcpa: false,
        event: null,
        officeId: null,
        type: null,
        dateRangeFrom: new Date(subDays(new Date(), 6)),
        dateRangeTo: new Date(),
    };
    const method = useForm({
        resolver: zodResolver(smsHistoricalRecordsAdvancedFilterSchema),
        reValidateMode: 'onChange',
        defaultValues,
    });
    const { control, handleSubmit, formState, reset, clearErrors } = method;
    const onSubmit = (data) => {
        setActiveFilters({
            ...data,
            recipient: null,
            dateRangeFrom: format(new Date(data.dateRangeFrom), DATE_FORMAT),
            dateRangeTo: format(new Date(data.dateRangeTo), DATE_FORMAT),
            officeId: offices.find((item) => item.value === data.officeId?.toString()) ||
                null,
            event: events.find((item) => item.value === data.event?.toString()) || null,
            type: types.find((item) => item.value === data.type?.toString()) || null,
        });
    };
    const handleOnSubmit = async () => {
        const rs = await method.trigger();
        if (rs) {
            return handleSubmit(onSubmit)();
        }
        else {
            return Promise.reject();
        }
    };
    return {
        method,
        control,
        handleSubmit: handleOnSubmit,
        formState,
        reset,
        clearErrors,
        offices,
        types,
        events,
    };
};
export default useAdvancedFilterForm;
